export type AnalyticsSection = 'origins' | 'heatmap' | 'profiles' | 'trends';

export type AnalyticsSectionPreferences = Record<AnalyticsSection, boolean>;

export const analyticsSectionPreferenceKey = 'wyscout-analytics-sections:v1';

export const defaultAnalyticsSectionPreferences: AnalyticsSectionPreferences = {
  origins: true,
  heatmap: true,
  profiles: true,
  trends: true,
};

const sections: AnalyticsSection[] = ['origins', 'heatmap', 'profiles', 'trends'];

export const readAnalyticsSectionPreferences = (
  storage?: Storage,
): AnalyticsSectionPreferences => {
  try {
    const raw = (storage ?? window.localStorage).getItem(analyticsSectionPreferenceKey);
    if (!raw) return {...defaultAnalyticsSectionPreferences};

    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {...defaultAnalyticsSectionPreferences};
    }

    return sections.reduce((result, section) => ({
      ...result,
      [section]: typeof (parsed as Record<string, unknown>)[section] === 'boolean'
        ? (parsed as Record<string, boolean>)[section]
        : true,
    }), {...defaultAnalyticsSectionPreferences});
  } catch {
    return {...defaultAnalyticsSectionPreferences};
  }
};

export const writeAnalyticsSectionPreferences = (
  preferences: AnalyticsSectionPreferences,
  storage?: Storage,
): void => {
  try {
    (storage ?? window.localStorage).setItem(analyticsSectionPreferenceKey, JSON.stringify(preferences));
  } catch {
    // Storage can be unavailable or full; persistence must not break the dashboard.
  }
};
